/**
 *  @author: Maximilian Gertz
 *  @email: mgertz@nanocosmos.net
 *  @organization: Nanocosmos GmbH
 *  @version: (introduced in analytics-front) 2.26.0
 */

import styled from 'styled-components';

export const ContentWrapper = styled.div``;
ContentWrapper.displayName = 'ContentWrapper';

export const AlertSubtitle = styled.div`
   font-size: 80%;
   color: #6c757d;
`;
AlertSubtitle.displayName = 'AlertSubtitle';

export const TimelineSectionWrapper = styled.div``;
TimelineSectionWrapper.displayName = 'TimelineSectionWrapper';

export const ConnectionRow = styled.div`
   margin-top: ${(props) => props.$marginTopPx || 0}px;
`;
ConnectionRow.displayName = 'ConnectionRow';

export const ConnectionLabel = styled.div`
   font-size: 11px;
   color: #8a8a8a;
   margin-bottom: 2px;
`;
ConnectionLabel.displayName = 'ConnectionLabel';

export const TimelineBar = styled.div`
   position: relative;
   width: 100%;
   height: 20px;
   background-color: rgba(128, 128, 128, 0.1);
   border-radius: 4px;
   overflow: hidden;
`;
TimelineBar.displayName = 'TimelineBar';

export const AlertMarker = styled.div`
   position: absolute;
   top: 0;
   width: 3px;
   height: 100%;
   background-color: rgb(60, 120, 220);
   cursor: pointer;
   z-index: 1;
`;
AlertMarker.displayName = 'AlertMarker';

export const SegmentFill = styled.div`
   position: absolute;
   top: 0;
   height: 100%;
   background-color: ${(props) => props.$color};
   cursor: pointer;
`;
SegmentFill.displayName = 'SegmentFill';

export const DpMarker = styled.div`
   position: absolute;
   top: 0;
   width: 3px;
   height: 100%;
   background-color: ${(props) => props.$color || 'transparent'};
   cursor: pointer;
   z-index: 2;
`;
DpMarker.displayName = 'DpMarker';

export const LegendContainer = styled.div`
   display: flex;
   gap: 16px;
   margin-top: 15px;
   margin-bottom: 20px;
   font-size: 11px;
   color: #8a8a8a;
`;
LegendContainer.displayName = 'LegendContainer';

export const LegendItem = styled.div`
   display: flex;
   align-items: center;
   gap: 4px;
`;
LegendItem.displayName = 'LegendItem';

export const LegendLabel = styled.span``;
LegendLabel.displayName = 'LegendLabel';

export const LegendColorBox = styled.div`
   width: 10px;
   height: 10px;
   border-radius: 2px;
   background-color: ${(props) => props.$color};
`;
LegendColorBox.displayName = 'LegendColorBox';
